const initialDadosPessoais = {
  nome: '',
  conjuge: '',
  estadoCivil: '',
  dataNascimento: '',
  estadoNascimento: '',
  nacionalidade: '',
  naturalidade: '',
  genero: '',
  pai: '',
  mae: '',
  cpf: '',
  rg: '',
  orgaoEmissorRg: '',
  dataExpedicaoRg: '',
  ufExpedicaoRg: '',
  idade: 0,
  maiorIdade: true,
  dataAdmissao: '',
  dataAfastamento: '',
  DataDesligamento: '',
  motivoAfastamento: '',
  motivoDesligamento: '',
  DataFimBeneficio: '',
  DataInicioBeneficio: '',
  matriculaFalecido: '',
  motivoEncerramento: '',
  numDependentes: '',
  mensagem: '',
  sitPartPlano: '',
  statusPlano: '',
  tipoBeneficio: '',
  planoPrevidencia: [],
  endereco: {
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    pais: '',
    cep: '',
    email: '',
    celular: '',
    telefone: '',
  },
  bancarios: {
    banco: '',
    agencia: '',
    conta: '',
    digito: '',
  },
};

const initialDadosSAPNaoTratados = {
  matricula: '',
  nome: '',
  matriculaFalecido: '',
  dependente: '',
  cep: '',
  endereco: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  estado: '',
  telefoneFixo: '',
  celular: '',
  email: '',
  dtNascimento: '',
  sexo: '',
  mae: '',
  pai: '',
  conjuge: '',
  cpf: '',
  rg: '',
  orgEmissor: '',
  uf: '',
  dtEmissao: '',
  localNascimento: '',
  estadoNasc: '',
  pais: '',
  nacionalidade: '',
  estadoCivil: '',
  numBanco: '',
  agencia: '',
  conta: '',
  status: '',
  dtAdminissao: '',
  dtDesligamento: '',
  motivoDeslig: '',
  dtAfastamento: '',
  motivoEncerramento: '',
  tpBeneficio: '',
  dtEncerramentoBeneficio: '',
  motivoAfastamento: '',
  planoPrevidencia: [],
  situacaoParticipante: '',
};

export const initialState = {
  isLogged: false,
  isLoading: false,
  error: '',
  data: {
    token: '',
    matricula: '',
    plano: '',
  },
  dadosPessoais: initialDadosPessoais,
  dadosSAPNaoTratados: initialDadosSAPNaoTratados,
  alteracaoDadosPessoais: { editMode: false, data: [] },
  pendencias: {},
  extrato: {
    plano: '',
    cnpb: '',
    habilitar: {
      SimuladorBeneficio: false,
      InformeRendimentos: false,
      ExtratoSaldoContas: false,
      Beneficiarios: false,
      ExaurimentoBeneficio: false,
      Contribuicoes: false,
      CertificadoAdesao: false,
    },
  },
  mensageria: [],
  mensagensPendentes: false,
};
